
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const ServiceNotFound = () => {
  const navigate = useNavigate();
  
  return (
    <div className="rounded-md border border-brand-cloud bg-white p-8 text-center shadow-sm">
      <AlertCircle className="mx-auto mb-4 h-12 w-12 text-red-500" />
      <h2 className="mb-2 public-section-title">Service Not Found</h2>
      <p className="mb-6 text-brand-slate">
        The service you're looking for doesn't exist or has been removed.
      </p>
      <Button className="rounded-md bg-brand-ink text-white hover:bg-brand-charcoal" onClick={() => navigate("/explore")}>
        Browse Services
      </Button>
    </div>
  );
};

export default ServiceNotFound;
